<template>
    <div class="w-full px-5 pt-3">
        <div class="flex justify-start items-center space-x-3 mb-1">
       
         
        </div>
      
        <div class="overflow-x-auto mx-0">
          <div class="py-2 align-middle inline-block min-w-full">
            <div
              class="border overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-100">
                  <tr>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Ид
                      
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Полное имя
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Адрес
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Электронная почта
                    
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Телефонный номер
                    
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Дата
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Примечание
                    
                    </th>
                    <th
                      scope="col"
                      class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                    Загружаемый файл
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr
                    v-for="(item, index) in paginatedData"
                    :key="index"
                  >
                    <td
                      class="whitespace-nowrap text-sm text-gray-500 font-mono border-r text-center"
                    >
                      {{ item.id }}
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.fullName }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.address }}
                      </p>
                    </td>    
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.email }}
                      </p>
                    </td>  
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.phoneNumber }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ formatedDate(item.dateOfSending) }}
                      </p>
                    </td> 
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                        {{ item.note }}
                      </p>
                    </td>  
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x"
                    >
                      <p
                        class="text-base whitespace-normal text-justify"
                      >
                      <button
                        @click="DownloadFile(index)"
                        class="hover:text-blue-500">
                        <img src="../assets/pdf.png" alt="pdf" width="35"
                                       height="35">
                      </button>
                      </p>
                    </td>  
                  </tr>
                  <tr v-if="filteredData.length === 0">
                    <td
                      colspan="2"
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      Запрашиваемый элемент не найден.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="flex flex-col items-end mt-1">
                    <div class="flex text-gray-700 space-x-1">
                      <button
                        @click="previousPage"
                        :disabled="currentPage === 1"
                        class="h-7 w-7 flex justify-center items-center bg-white border hover:text-blue-500 hover:border-blue-500 transition-all ease-linear cursor-pointer rounded-md"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="4"
                          height="4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-chevron-left w-6 h-6"
                        >
                          <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                      </button>
                      <span
                        v-for="pageNumber in pageNumbers"
                        :key="pageNumber"
                        class="flex h-7 font-medium bg-white border transition-all ease-linear rounded-md"
                      >
                        <button
                          @click="goToPage(pageNumber)"
                          :disabled="currentPage === pageNumber"
                          :class="{ active: currentPage === pageNumber }"
                          class="w-7 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-md"
                        >
                          {{ pageNumber }}
                        </button>
                      </span>
                      <button
                        @click="nextPage"
                        :disabled="currentPage === totalPages"
                        class="h-7 w-7 ml-1 flex justify-center items-center bg-white border hover:text-blue-500 hover:border-blue-500 transition-all ease-linear cursor-pointer rounded-md"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="4"
                          height="4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-chevron-right w-6 h-6"
                        >
                          <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                      </button>
                    </div>
              </div>
          </div>
        </div>
      </div>

    <div v-show="loading">
    <LoadingPage message="Выполняется загрузка ..."></LoadingPage>
    </div>
  </template>
  
  <script>
  import LoadingPage from "./LoadingPage.vue";
  export default {
    beforeRouteEnter(to, from, next) {
      sessionStorage.removeItem("CURRENT_ONLINE_APPEAL");
      next();
    },
    components: {
      LoadingPage
    },
    data() {
      return {
        currentPage: 1,
        itemsPerPage: 7,
        searchQuery: "",
        onlineAppeals: [],
        loading: true
      };
    },
    computed: {
      filteredData() {
        let filteredItems = this.onlineAppeals;
  
        if (this.searchQuery) {
          filteredItems = filteredItems.filter((item) => {
            return item.keyWordRu
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase());
          });
        }
  
        return filteredItems;
      },
      paginatedData() {
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        return this.filteredData.slice(startIndex, endIndex);
      },
      totalPages() {
        return Math.ceil(this.filteredData.length / this.itemsPerPage);
      },
      pageNumbers() {
        const pages = [];
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
        return pages;
      },
    },
    methods: {
      async loadTableData() {
        this.axios
          .get("/api/Info/OnlineAppeal/GetOnlineAppealsInfo")
          .then((response) => {
            this.onlineAppeals = response.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      formatedDate(item) {
      const dateTime = new Date(item);
      return dateTime.toLocaleDateString();
    },
      async DownloadFile(index) {
    if (!this.onlineAppeals || !this.onlineAppeals[index]) {
        return;
    }

    let onlineAppeal = this.onlineAppeals[index];
    if (!onlineAppeal.onlineAppealFileId) {
        return;
    }

    try {
        let response = await this.axios.get("/api/Info/File/GetOnlineAppealInfoFileId/" + onlineAppeal.onlineAppealFileId, {
            responseType: 'blob'
        });

        let blob = new Blob([response.data], { type: response.headers['content-type'] });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.download = onlineAppeal.onlineAppealFileName;
        link.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.log(error);
    } finally {
        this.loading = false;
    }
},

      previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
        }
      },
      goToPage(pageNumber) {
        this.currentPage = pageNumber;
      },
    },
    mounted() {
      this.loadTableData();
    },
  };
  </script>
  
  <style>
  .active {
    background-color: #3b82f6;
    color: white;
  }
  .btn {
    margin-left: auto;
  }
  </style>
